import type { ProtocolEnum } from 'src/api/main'

export type ProviderCatalogPreset = {
  id: string
  labelKey: string
  protocol: ProtocolEnum
  scope: string
  issuerUrl?: string
  authorizeUrl?: string
  tokenUrl?: string
  jwksUrl?: string
}

export const PROVIDER_CATALOG_PRESETS: ProviderCatalogPreset[] = [
  {
    id: 'magic_link',
    labelKey: 'authMethods.catalog.magicLink',
    protocol: 'oauth2',
    scope: 'email'
  },
  {
    id: 'github_oidc',
    labelKey: 'authMethods.catalog.github',
    protocol: 'oauth2',
    scope: 'read:user user:email'
  },
  {
    id: 'okta_saml',
    labelKey: 'authMethods.catalog.oktaSaml',
    protocol: 'saml2',
    scope: ''
  }
]
